import { render } from "./IconSwapHorizontal.vue?vue&type=template&id=6ddda1b5"
import script from "./IconSwapHorizontal.vue?vue&type=script&lang=js"
export * from "./IconSwapHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconSwapHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ddda1b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ddda1b5', __exports__)) {
    api.reload('6ddda1b5', __exports__)
  }
  
  module.hot.accept("./IconSwapHorizontal.vue?vue&type=template&id=6ddda1b5", () => {
    api.rerender('6ddda1b5', render)
  })

}


export default __exports__